import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'

import './journal-excerpt.css'

const JournalExcerpt = (props) => (
  <div className='journal-excerpt'>
    <div className='row'>
      <div className='col-xs-12 col-sm-6'>
        {props.image && (
          <Link to={props.href} className='journal-excerpt__img'>
            <img src={props.image} alt={props.title} />
          </Link>
        )}
      </div>
      <div className='col-xs-12 col-sm-6'>
        <h3><Link to={props.href}>{props.title}</Link></h3>
        <span className='journal-excerpt__time'>{props.time}</span>
        {props.text && (
          <div className='journal-excerpt__text'>{ReactHtmlParser(props.text)}</div>
        )}
        <Link to={props.href} className='journal-excerpt__more hoverable-link'>Read More —</Link>
      </div>
    </div>
  </div>
)

JournalExcerpt.propTypes = {
  title: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  href: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired
}

export default JournalExcerpt



// WEBPACK FOOTER //
// ./src/components/Page/Content/JournalExcerpt/index.js